import StoriesService from '@/services/stories/stories.service.js';

export default StoriesService;
